import { Validator } from "vee-validate"
import ValidationRules from "./ValidationRules"

const iterateOverRules = ruleName => ({
	name: ruleName,
	config: ValidationRules[ruleName]
})
const extendRulesToVee = rule => Validator.extend(rule.name, rule.config)

// Init Custom Rules
const initCustomRules = () => {
	// iterate over validation rules to assign to Validator extend
	return Object.keys(ValidationRules)
		.map(iterateOverRules)
		.forEach(extendRulesToVee)
}

export default initCustomRules
